/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var noOp = function () { };
exports.throwMaximumDurationExceeded = function () {
    throw new Error("maximumDuration exceeded");
};
var AsyncStateTransformer = /** @class */ (function (_super) {
    tslib_1.__extends(AsyncStateTransformer, _super);
    function AsyncStateTransformer(props) {
        var _this = _super.call(this, props) || this;
        _this.steps = props.steps.slice();
        _this.state = _this.props.initialState;
        return _this;
    }
    AsyncStateTransformer.prototype.componentDidMount = function () {
        this.shouldBeMounted = true;
        if (this.props.running) {
            this.run();
        }
    };
    AsyncStateTransformer.prototype.componentWillUnmount = function () {
        this.shouldBeMounted = false;
    };
    AsyncStateTransformer.prototype.componentWillReceiveProps = function (_a) {
        var running = _a.running, steps = _a.steps, initialState = _a.initialState;
        if (running && !this.props.running) {
            this.steps = steps.slice();
            this.run();
        }
        else if (!running) {
            this.setState(tslib_1.__assign({}, initialState));
        }
    };
    AsyncStateTransformer.prototype.run = function () {
        var _this = this;
        this.loop()
            .then(function () {
            _this.props.onDone(tslib_1.__assign({}, _this.state));
        })
            .catch(function (err) { return _this.props.onError(err); });
    };
    AsyncStateTransformer.prototype.setStateAsync = function (state) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) { return _this.setState(state, function () { return resolve(); }); })];
            });
        });
    };
    AsyncStateTransformer.prototype.loop = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var step, state, result, error_1, result, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.steps.length) return [3 /*break*/, 15];
                        if (!this.shouldBeMounted) {
                            throw new Error("Component was unmounted during state transition");
                        }
                        step = this.steps.shift();
                        state = void 0;
                        if (!step) {
                            return [3 /*break*/, 0];
                        }
                        if (!(typeof step.state === "function")) return [3 /*break*/, 9];
                        if (!step.maximumDuration) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Promise.race([
                                Promise.all([
                                    step.state(tslib_1.__assign({}, this.state)),
                                    AsyncStateTransformer.asyncTimeout(step.minimumDuration)
                                ]),
                                AsyncStateTransformer.asyncTimeout(step.maximumDuration).then(exports.throwMaximumDurationExceeded)
                            ])];
                    case 2:
                        result = _a.sent();
                        state = result[0];
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        throw error_1;
                    case 4: return [3 /*break*/, 8];
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, Promise.all([
                                step.state(tslib_1.__assign({}, this.state)),
                                AsyncStateTransformer.asyncTimeout(step.minimumDuration)
                            ])];
                    case 6:
                        result = _a.sent();
                        state = result[0];
                        return [3 /*break*/, 8];
                    case 7:
                        err_1 = _a.sent();
                        throw err_1;
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        if (!!step.state) {
                            state = step.state;
                        }
                        _a.label = 10;
                    case 10:
                        if (!state) return [3 /*break*/, 12];
                        return [4 /*yield*/, this.setStateAsync(state)];
                    case 11:
                        _a.sent();
                        _a.label = 12;
                    case 12:
                        if (!(step.minimumDuration && typeof step.state !== "function")) return [3 /*break*/, 14];
                        return [4 /*yield*/, AsyncStateTransformer.asyncTimeout(step.minimumDuration)];
                    case 13:
                        _a.sent();
                        _a.label = 14;
                    case 14: return [3 /*break*/, 0];
                    case 15: return [2 /*return*/];
                }
            });
        });
    };
    AsyncStateTransformer.prototype.render = function () {
        var _a = this.props, _b = _a.children, children = _b === void 0 ? null : _b, running = _a.running, initialState = _a.initialState, steps = _a.steps, onDone = _a.onDone, onError = _a.onError, restProps = tslib_1.__rest(_a, ["children", "running", "initialState", "steps", "onDone", "onError"]);
        var state = tslib_1.__rest(this.state, []);
        if (typeof children === "function") {
            return children(tslib_1.__assign({}, state, restProps));
        }
        return null;
    };
    AsyncStateTransformer.propTypes = {
        initialState: PropTypes.object.isRequired,
        steps: PropTypes.arrayOf(PropTypes.shape({
            minimumDuration: PropTypes.number,
            maximumDuration: PropTypes.number,
            state: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
        })).isRequired,
        onDone: PropTypes.func,
        onError: PropTypes.func,
        running: PropTypes.bool.isRequired
    };
    AsyncStateTransformer.defaultProps = {
        onDone: noOp,
        onError: noOp
    };
    AsyncStateTransformer.asyncTimeout = function (ms) {
        if (ms === void 0) { ms = 0; }
        return new Promise(function (resolve) { return setTimeout(resolve, ms); });
    };
    return AsyncStateTransformer;
}(React.Component));
exports.AsyncStateTransformer = AsyncStateTransformer;